import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true,
      },
    });
    this.appInsights.loadAppInsights();
    this.addUserTelemetryInitializer();
  }

  setUser(upn: string, accountId?: string) {
    if (!upn) { return; }
    this.appInsights.setAuthenticatedUserContext(upn, accountId, true);
  }

  clearUser() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  private addUserTelemetryInitializer() {
    this.appInsights.addTelemetryInitializer((envelope) => {
      const upn = this.appInsights.context.user?.authenticatedId;
      if (upn) {
        const baseData: any = (envelope as any).data?.baseData;
        if (baseData) {
          baseData.properties = baseData.properties || {};
          baseData.properties.UserUPN = upn;
        }
      }
    });
  }

  logPageView(name?: string, url?: string) {
    this.appInsights.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}